module.exports = __webpack_public_path__ + "static/6305-woodrose-39-d75ec4ea1c552216fa0a466a83e8206b.jpg";